export const config = {
  name: 'production',
  environment: 'production',

  couchUrl: 'https://ephemeral.fltbx.xyz:6984/',
  dbName: ''
};



// WEBPACK FOOTER //
// ./config/production.ts